if (!customElements.get("custom-error-popup")) {
  customElements.define(
    "custom-error-popup",
    class CustomErrorPopup extends HTMLElement {
      handle = "on";
      constructor() {
        super();

        this.button = this.querySelector("a.remove-button");

        this.button.addEventListener("click", (e) => {
          e.preventDefault();
          this.hide();
        });
      }
      show() {
        if (this.classList.contains(this.handle) == false) {
          this.classList.add(this.handle);
        }
      }
      hide() {
        if (this.classList.contains(this.handle) == true) {
          this.classList.remove(this.handle);
        }
      }
    }
  );
}

if (!customElements.get("product-custom-options")) {
  customElements.define(
    "product-custom-options",
    class ProductCustomOptions extends HTMLElement {
      constructor() {
        super();

        this.loading_class = "custom-product-loading";
        this.loading_on = () => {
          if (error_container != null) {
            if (
              error_container.classList.contains(this.loading_class) == false
            ) {
              error_container.classList.add(this.loading_class);
            }
          }
        };
        this.loading_off = () => {
          if (error_container != null) {
            if (error_container.classList.contains(this.loading_class)) {
              error_container.classList.remove(this.loading_class);
            }
          }
        };

        this.unsubscriber = {
          success: null,
          failure: null,
        };

        const error_element = this.querySelector("custom-error-popup");
        const container_href =
          error_element !== null ? error_element.dataset.href : null;
        const error_container =
          container_href != null
            ? document.getElementById(container_href)
            : null;

        this.error =
          error_container !== null
            ? error_container.appendChild(error_element)
            : error_element;
        this.select = this.querySelector(
          "select.select-custom-option:has(option.charged)"
        );

        this.updateSuccess = () => {
          const option = this.select.options[this.select.selectedIndex];

          if (option.classList.contains("charged") == true) {
            const variantId = option.dataset.chargeId;
            const inventory = option.dataset.chargeQuantity;

            let quantity =
              document.querySelector('input.quantity__input[name="quantity"]')
                .value || 1;

            try {
              if (inventory < quantity)
                throw new Error("Quantity Over Inventory");
            } catch (e) {
              quantity = inventory;

              if (this.error != null) this.error.show();
            } finally {
              const remain = inventory - quantity;

              [...this.select.options].forEach((option, i) => {
                if (option.dataset.chargeId == variantId) {
                  option.dataset.chargeQuantity = remain;
                  if (remain == 0) option.disabled = true;
                }
              });

              this.select.selectedIndex = 0;

              if (quantity > 0) {
                this.loading_on();

                this.addCartOptionProduct(
                  variantId,
                  quantity,
                  this.loading_off,
                  this.loading_off
                );
              }
            }
          }

          this.initUnSubscriber();
        };
        this.updateFailure = () => {
          console.log("UPDATE FAILURE");

          this.initUnSubscriber();
        };

        this.select.addEventListener("change", (e) => {
          const option = e.target.options[e.target.selectedIndex];

          this.initUnSubscriber();

          if (option.classList.contains("charged") == true) {
            this.unsubscriber.success = subscribe(
              PUB_SUB_EVENTS.cartUpdate,
              this.updateSuccess
            );
            this.unsubscriber.failure = subscribe(
              PUB_SUB_EVENTS.cartError,
              this.updateFailure
            );
          }
        });
      }

      initUnSubscriber() {
        for (let key in this.unsubscriber) {
          if (this.unsubscriber[key] != null) {
            this.unsubscriber[key]();
            this.unsubscriber[key] = null;
          }
        }
      }

      addCartOptionProduct(
        variantId,
        quantity,
        success = false,
        failure = false
      ) {
        const data = {
          id: variantId,
          quantity: quantity,
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((error) => {
                throw new Error(error.description);
              });
            }
            return response.json();
          })
          .then((data) => {
            if (success !== false && typeof success === "function") {
              success();
            }
          })
          .catch((error) => {
            if (failure !== false && typeof failure === "function") {
              failure();
            }
          });
      }
    }
  );
}
